import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const storedUserDetails = localStorage.getItem("userdetails");
const token = storedUserDetails ? JSON.parse(storedUserDetails).token.replace(/^"(.*)"$/, '$1') : null;
interface ErrorResponse {
  status: number;
  message: string;
}

export const getEarningsDeductionType = (
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios.get(`${global.api_url}/api/earning_deduction_types?per_page_records=100&page_number=0`, {
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else if (error.response?.status === 404){
          _errorCallBack(error.response.data);
        }
        else{
          toast.error("Server Error");
        }
      }
    );
  };
   export const getEarningDeductionTypeWarehouse = (
    warehouses_id:any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios.get(`${global.api_url}/api/earn_deduct_types_warehouses?per_page_records=150&page_number=0&warehouses_id=${warehouses_id}&earnings_type=&fuel_type=`, {
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else if (error.response?.status === 404){
          _errorCallBack(error.response.data);
        }
        else{
          toast.error("Server Error");
        }
      }
    );
  };
  export const getWarehouseCompanyMapping = (
       companies_id:any,
        _successCallBack?: (response: any) => void,
        _errorCallBack?: (errMessage: any) => void,
      ) => {
        const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
        const headers = {
          Authorization: `Bearer ${userDetailsFromStorage?.token}`,
        };
      
      
        axios
          .get(`${global.api_url}/api/warehouses_companies?companies_id=${companies_id}`, { headers })
          .then((response: AxiosResponse) => {
            if (response.status === 200 || response.status === 201) {
              _successCallBack?.(response.data);
            } else {
              _errorCallBack?.(`Unexpected status code: ${response.status}`);
            }
          })
          .catch((error: AxiosError<any>) => {
            console.log("Error caught:", error);
      
            if (error.response) {
              const { status, data } = error.response;
      
              if (status === 400 || status === 404) {
                _errorCallBack?.(data);
              } else if (status === 401) {
                localStorage.clear();
              } else {
                _errorCallBack?.(`Error ${status}: ${data?.message || "Unknown error"}`);
              }
            } else {
              _errorCallBack?.("Network or server error");
            }
          });
      };
  export const getFrequencyType = (
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios.get(`${global.api_url}/api/frequency_types?per_page_records=100&page_number=0`, {
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else if (error.response?.status === 404){
          _errorCallBack(error.response.data);
        }
        else{
          toast.error("Server Error");
        }
      }
    );
  };
  export const addEarningDeductionTypesWarehouse = (
  earnings_deductions_types_id: string | '', 
  warehouses_id: string | '',  
  amount: number | null,          
  fuel_type: string | '', 
  companies_owners_id:string|'',
  frequency_type_id:string|'',          
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`, 
    'Content-Type': 'application/json',
  };
  const payload = {
     earnings_deductions_types_id,
     warehouses_id,
     amount,
     fuel_type,
     companies_owners_id,
     frequency_type_id
  };
  axios
    .post(`${global.api_url}/api/earn_deduct_types_warehouses`, payload, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        _successCallBack(response.data);
      }
      else if(response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 404) {
        _errorCallBack(error.response.data);
      }else if (error.response?.status === 401) {
        localStorage.clear();
      } 
    });
};
 export const addTransaction = (
   users_id: string | '',  
  warehouses_id: number | null,   
  earnings_deductions_types_id:string |null,       
  count_txn: string | '', 
  txn_amount:string|'',
  trips_id:string |'',
  accounting_period:string | '',
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`, 
    'Content-Type': 'application/json',
  };
  const payload = {
    users_id,
     warehouses_id,
     earnings_deductions_types_id,
      count_txn,
     txn_amount,
     trips_id,
     accounting_period,
  };
  axios
    .post(`${global.api_url}/api/txns_earnings_deductions`, payload, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        _successCallBack(response.data);
      }
      else if(response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 404) {
        _errorCallBack(error.response.data);
      }else if (error.response?.status === 401) {
        localStorage.clear();
      } 
    });
};
export const addFrequencyType = (
   name: string | '',  
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`, 
    'Content-Type': 'application/json',
  };
  const payload = {
  name
  };
  axios
    .post(`${global.api_url}/api/frequency_types`, payload, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        _successCallBack(response.data);
      }
      else if(response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 404) {
        _errorCallBack(error.response.data);
      }else if (error.response?.status === 401) {
        localStorage.clear();
      } 
    });
};
export const addEarningType = (
   name: string | '', 
   type:string|'',
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`, 
    'Content-Type': 'application/json',
  };
  const payload = {
  name,
  type
  };
  axios
    .post(`${global.api_url}/api/earning_deduction_types`, payload, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        _successCallBack(response.data);
      }
      else if(response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 404) {
        _errorCallBack(error.response.data);
      }else if (error.response?.status === 401) {
        localStorage.clear();
      } 
    });
};
export const getDriversEarnings = (
  per_page_records: number,
  page_number: number,
  accounting_period:any,
 _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: string, statusCode?: number) => void
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`,
  };
  axios
    .get(`${global.api_url}/api/drivers_transactions?accounting_period=${accounting_period}&per_page_records=${per_page_records}&page_number=${page_number}`, {
      headers: headers,
    })
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        _successCallBack(response.data);
      }
      else if(response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      const errorData = error.response?.data as ErrorResponse | undefined;
      const errorMessage = errorData?.message || "Unknown Error";
      const statusCode = error.response?.status;
      _errorCallBack(errorMessage, statusCode);
    });
};
export const getDriversEarningsDeductions = (
  per_page_records: number,
  page_number: number,
 users_id:number|null,
 _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: string, statusCode?: number) => void
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`,
  };
  axios
    .get(`${global.api_url}/api/txns_earnings_deductions?per_page_records=100&page_number=0&users_id=${users_id}`, {
      headers: headers,
    })
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        _successCallBack(response.data);
      }
      else if(response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      const errorData = error.response?.data as ErrorResponse | undefined;
      const errorMessage = errorData?.message || "Unknown Error";
      const statusCode = error.response?.status;
      _errorCallBack(errorMessage, statusCode);
    });
};
